const LINK_PURPOSES = new Set([
  "verification",
  "identity_change",
  "contact_sign_in",
  "reset",
  "password_change",
]);

export function readVerificationLinkPurpose(token) {
  const raw = String(token || "").trim();
  if (!raw) return null;
  try {
    const base64 = raw.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const decoded = atob(padded);
    const [version, userId, purpose, sessionId, otp, ...extra] = decoded.split(":");
    if (
      extra.length ||
      version !== "v2" ||
      !/^[a-f0-9]{24}$/i.test(userId) ||
      !LINK_PURPOSES.has(purpose) ||
      !/^otp_[A-Za-z0-9_-]{16,128}$/.test(sessionId) ||
      !/^\d{6}$/.test(otp)
    ) {
      return null;
    }
    return purpose;
  } catch {
    return null;
  }
}
